// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FlagBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M4.018 4.86A1.5 1.5 0 0 0 3.5 6v21a1.5 1.5 0 0 0 3 0v-5.285c2.855-2.14 5.262-1.14 8.835.625 2.029 1 4.342 2.15 6.85 2.15 1.84 0 3.785-.617 5.798-2.36A1.5 1.5 0 0 0 28.5 21V6a1.5 1.5 0 0 0-2.483-1.134c-3.088 2.677-5.566 1.664-9.352-.21C13.149 2.91 8.771.743 4.018 4.86ZM25.5 20.282c-2.855 2.142-5.262 1.14-8.835-.625C13.77 18.22 10.291 16.5 6.5 18.234V6.71c2.855-2.14 5.262-1.14 8.835.625 2.029 1 4.342 2.15 6.85 2.15A7.875 7.875 0 0 0 25.5 8.76v11.522Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
